import { FC } from "react"

export const SvgGlobal: FC = () => {
  return (
    <svg style={{ position: "absolute", top: "-10000px", left: "-10000px" }}>
      <defs id="svg-defs">
        <clipPath
          id="active-effects-item-content-mask"
          clipPathUnits="objectBoundingBox"
          transform="scale(0.04761904762, 0.04347826087)"
        >
          <path d="M9.24754 22.6098L0.5071 17.6584C0.193704 17.4808 0 17.1485 0 16.7883V5.77134C0 5.40125 0.204398 5.06143 0.531324 4.88797L9.5265 0.115553C9.81111 -0.0354514 10.1511 -0.0400718 10.4397 0.103142L19.6311 4.66401C19.9714 4.83286 20.1866 5.17993 20.1866 5.55979V16.1122C20.1866 16.4646 20.0011 16.7909 19.6984 16.9713L10.2522 22.5988C9.94362 22.7827 9.5601 22.7868 9.24754 22.6098Z" />
        </clipPath>
      </defs>
    </svg>
  )
}
